import styled from 'styled-components';

export const LevelZeroWrap = styled.div`
  margin-bottom: 8px;
  background: ${(props) => props.theme.colors.neutral50};
  box-shadow: ${(props) => props.theme.shadows.shadowXS};
  border-radius: 15px;
  min-width: 680px;
  padding: 12px 15px;
  width: 100%;
  display: fixed;
  align-items: center;
  justify-content: space-between;
  color: #fefefe;
  text-align: center;
  position: relative;
  > div {
    width: calc(100% / 3);
  }
`;
